import App from './App.vue'
import Meta from 'vue-meta'
Vue.use(Meta)
// const Home = require('./home').default
const ErrorPage = require('./404').default
const Trademark = require('./trademark').default
const RegisterTrademark = require('./trademarkform').default
const TrademarkSuccess = require('./trademarksuccess').default
const routes = [{
    path: '/trademark',
    component: Trademark
  },
  {
    path: '/trademark/trademark-form',
    component: RegisterTrademark
  },
  {
    path: '/trademark/trademark-success',
    component: TrademarkSuccess
  },
  {
    path: '/trademark/404',
    component: ErrorPage
  }
  
]

const router = new VueRouter({
  routes,
  mode: 'history',
  // mode: 'hash',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})

new Vue({
  el: '#app',
  router,
  render: h => h(App),
  mounted() {
    // You'll need this for renderAfterDocumentEvent.
    document.dispatchEvent(new Event('render-event'))
  }
})



// WEBPACK FOOTER //
// ./src/main.js